// extracted by mini-css-extract-plugin
var _1 = "UserProfileHeader-moduletitle__kJxdy EntityProfileHeaderTitleWithStatus-moduleEntityProfileHeaderTitleWithStatus__vrABE";
export { _1 as "title" }
